import {useFormik} from "formik";
import {Button, Input, Modal} from "antd";
import React, {useState} from "react";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useApiUpdateAdminProfile} from "@/api/userAcademy";
import CleaveInput from "@/components/cleave-input/cleaveInput";
import {useApiLocationCountry} from "@/api/location";
import {ErrorMessageWidget, FormField} from "@/pages/student/profile/_section/changeLocationModal";
import {formatMobileNumber} from "@/lib/utils/number";
import {useParams} from "react-router-dom";

export default function ChangeMobileModal({user, onSubmit, onClose, openModal}) {
    const [loading, setLoading] = useState(false);

    const {data: country} = useApiLocationCountry()

    const {mutate: updateProfile} = useApiUpdateAdminProfile();

    const params = useParams();

    const formik = useFormik({
        initialValues: {
            mobile2: user?.mobile2,
            phone: user?.phone,
            email: user?.email,
            fathermobile: user?.fathermobile,
            mothermobile: user?.mothermobile,

        },
        validate: (values) => {
            const errors = {};
            // if (!values.firstname) errors.firstname = "نام الزامی است";
            // if (!values.lastname) errors.lastname = "نام خانوادگی الزامی است";
            // if (!values.father) errors.father = "نام پدر الزامی است";
            // if (!values.birthdate) errors.birthdate = "تاریخ تولد الزامی است";
            // if (!values.marital) errors.marital = "وضعیت تاهل الزامی است";

            return errors;
        },
        onSubmit: (values) => {
            values.id = params.id;
            setLoading(true);
            values.mobile2 = formatMobileNumber(values.mobile2);
            values.fathermobile = formatMobileNumber(values.fathermobile);
            values.mothermobile = formatMobileNumber(values.mothermobile);
            updateProfile(values, {
                onSuccess: (res) => {
                    onSubmit(res);
                    ApiHandleSuccessMessage(res);
                    setLoading(false);
                },
                onError: (errors) => {
                    ApiHandleErrorMessage(errors);
                    setLoading(false);
                },
            });
        },
    });

    return (
        <Modal
            title={"اطلاعات تماس و پل‌های ارتباطی خود را با دقت وارد کنید"}
            open={openModal}
            onCancel={() => {
                onClose?.();
            }}
            footer={[
                <Button onClick={() => onClose?.()}>لغو</Button>,
                <Button
                    type="primary"
                    loading={loading}
                    disabled={loading}
                    onClick={() => formik.submitForm()}
                >
                    ذخیره
                </Button>,
            ]}
        >
            <div className="flex flex-col gap-3">


                <FormField label="موبایل" name="mobile">
                    <CleaveInput
                        disabled={true}
                        readOnly={true}
                        style={{direction: 'ltr'}}
                        type="tel"
                        autoComplete="off"
                        value={user?.mobile}
                        name="mobile"


                    />

                </FormField>

                <FormField label="موبایل دوم" name="mobile2">
                    <CleaveInput
                        style={{direction: 'ltr'}}
                        type="tel"
                        autoComplete="off"
                        options={{delimiter: '', blocks: [12]}}
                        name="mobile2"
                        value={formik.values.mobile2}
                        onChange={(e) => formik.setFieldValue("mobile2", e.target.value)}

                    />
                    {formik.errors.mobile2 && <ErrorMessageWidget message={formik.errors.mobile2}/>}
                </FormField>


                <FormField label="تلفن ثابت" name="phone">
                    <CleaveInput
                        style={{direction: 'ltr'}}
                        type="tel"
                        autoComplete="off"
                        options={{delimiter: '', blocks: [12]}}
                        name="phone"
                        value={formik.values.phone}
                        onChange={(e) => formik.setFieldValue("phone", e.target.value)}

                    />
                    {formik.errors.phone && <ErrorMessageWidget message={formik.errors.phone}/>}
                </FormField>

                <FormField label="موبایل پدر" name="fathermobile">
                    <CleaveInput
                        style={{direction: 'ltr'}}
                        type="tel"
                        autoComplete="off"
                        options={{delimiter: '', blocks: [12]}}
                        name="fathermobile"
                        value={formik.values.fathermobile}
                        onChange={(e) => formik.setFieldValue("fathermobile", e.target.value)}

                    />
                    {formik.errors.fathermobile && <ErrorMessageWidget message={formik.errors.fathermobile}/>}
                </FormField>

                <FormField label="موبایل مادر" name="mothermobile">
                    <CleaveInput
                        style={{direction: 'ltr'}}
                        type="tel"
                        autoComplete="off"
                        options={{delimiter: '', blocks: [12]}}
                        name="mothermobile"
                        value={formik.values.mothermobile}
                        onChange={(e) => formik.setFieldValue("mothermobile", e.target.value)}

                    />
                    {formik.errors.mothermobile && <ErrorMessageWidget message={formik.errors.mothermobile}/>}
                </FormField>


                <FormField label="رایانامه" name="email">
                    <Input
                        style={{direction: 'ltr'}}

                        autoComplete="off"

                        name="email"
                        value={formik.values.email}
                        onChange={(e) => formik.setFieldValue("email", e.target.value)}

                    />
                    {formik.errors.email && <ErrorMessageWidget message={formik.errors.email}/>}
                </FormField>


            </div>
        </Modal>
    );
}
